import { getBackVersion } from '../../config';
import { InviteSnapshot } from '../../models/Referral/Invite';
import { ReceivedInviteSnapshot } from '../../models/Referral/ReceivedInvite';
import api from '../api';

const getInvite = (): Promise<InviteSnapshot> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/referral/invite`,
    });
};

const getInviteByCode = (code: string): Promise<ReceivedInviteSnapshot> => {
    return api.request({
        method: 'GET',
        url: `${getBackVersion()}/referral/invite/${code}`,
    });
};

const sendInvite = (email: string): Promise<void> => {
    return api.request({
        method: 'POST',
        data: {
            // eslint-disable-next-line camelcase
            target_email: email,
        },
        url: `${getBackVersion()}/referral/invite/send`,
    });
};

export { getInvite, sendInvite, getInviteByCode };
